import * as React from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import DrawerItem from './DrawerItem';

function DashboardMenuList({ title, menuItems }) {
  return (
    <>
      {title && (
        <ListSubheader component="div" inset>
          {title}
        </ListSubheader>
      )}

      {menuItems.map((item, index) => (
        <DrawerItem
          key={index}
          text={item.text}
          Icon={item.icon}
          to={item.to}
        />
      ))}
    </>
  );
}

export default DashboardMenuList;